import type { Person } from "~types/types";

type AuthorApiRequest = {
    authorSlug: string;
    authorType?: string;
    pageNumber?: number;
    preview?: string;
};

export async function fetchAuthorFromApi({
    authorSlug,
    pageNumber,
}: AuthorApiRequest) {
    const authorResponse = await fetch(
        `/lineup-next/api/author/${authorSlug}?pageNumber=${pageNumber}`
    );

    if (!authorResponse.ok) {
        throw new Error(
            `Error when fetching from api/author: ${await authorResponse.text()}`
        );
    }

    return (await authorResponse.json()) as Person;
}
